export default class BrowserUtils {

    static getUserLanguages() {
        return navigator.languages ? navigator.languages : (
                [navigator.language || navigator.userLanguage]
        );
    }

}